import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-77981f92"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "adding_item" }, "Add New User", -1));
import UserList from '../../components/crud/UserList.vue';
import { ModalsContainer, useModal } from 'vue-final-modal';
import ModalUser from '../../components/crud/ModalUser.vue';
import { ref, onMounted } from 'vue';
import 'vue-final-modal/style.css';
import '../../assets/styles/boot.min.css';
import '../../assets/styles/font.min.css';
import api from '../../api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserManagement',
    emits: ['editItem'],
    setup(__props, { emit: __emit }) {
        const users = ref([]);
        const emit = __emit;
        // Fetch users data
        const fetchUsers = async () => {
            console.log('fecth');
            try {
                const response = await api.get('user_list.php');
                if (response.data.status === 'success')
                    users.value = response.data.list;
            }
            catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        const editItem = async (_user) => {
            emit('editItem', _user);
        };
        // Use the useModal hook to create modal handling functions
        const { open, close } = useModal({
            component: ModalUser,
            attrs: {
                onConfirm() {
                    close();
                },
                onClosed() {
                    fetchUsers();
                },
                onOpen() {
                }
            },
            slots: {
                default: 'userform',
            }
        });
        onMounted(fetchUsers);
        return (_ctx, _cache) => {
            const _component_VButton = _resolveComponent("VButton");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_VButton, { onClick: _unref(open) }, {
                        default: _withCtx(() => [
                            _hoisted_2,
                            _createTextVNode(),
                            _hoisted_3
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                _createVNode(UserList, {
                    users: users.value,
                    onUpdateOrder: fetchUsers,
                    onEditItem: editItem
                }, null, 8, ["users"]),
                _createVNode(_unref(ModalsContainer))
            ]));
        };
    }
});
